import { useEffect, useState } from 'react';
import { artPieces, galleryOrder } from './shopItems';

export const galleryWorks = [...new Set(['screenprint0.jpg', 'relief7.jpg', 'litho2.jpg', 'intaglio2.jpg', ...galleryOrder])]
    .map(file => artPieces.find(piece => piece.file === file)).filter(Boolean);
export function orderWorks(works, order) {
    const positions = new Map(order.map((id, index) => [id, index]));
    return [...works].sort((a, b) => (positions.get(a.id) ?? Infinity) - (positions.get(b.id) ?? Infinity));
}
export function useGalleryOrder() {
    const [state, setState] = useState({ order: [], loading: true, error: '' });
    useEffect(() => {
        let active = true;
        fetch('/api/gallery-order').then(async response => {
            if (!response.ok) throw new Error('Could not load artwork order.');
            const data = await response.json();
            if (active) setState({ order: data.order || [], loading: false, error: '' });
        }).catch(error => { if (active) setState({ order: [], loading: false, error: error.message }); });
        return () => { active = false; };
    }, []);
    return state;
}
